import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Breadcrumb as Bc } from "antd";
import { withRouter } from "react-router-dom";
import { GetQuery, langCheck, getBreadCrumbInfo, getWindow, updateUrlInSesion, isInsideTab } from "Pub/js/utils";
import { openPage } from "Pub/js/superJump";
import { isPlainObject, cloneDeep } from "lodash";
import platform from "Pub/js/platform";
import { connect } from "react-redux";
const { base, PubSub } = platform;
const { NCMenu, NCDropdown } = base;
const { Item } = NCMenu;
import "./index.less";
const { ajax, getLangCode } = platform;
import DefaultIcon from "Assets/images/workbench_nav/workbench_logo.png";
import { setWorkbenchData } from "Store/appStore/action";
import TooltipText from "Components/TooltipText";

class Breadcrumb extends Component {
    constructor(props) {
        super(props);
        let { b1, b2, b3, b4, n } = GetQuery(this.props.location.search);
        this.state = { breadcrumbInfo: { b1, b2, b3, b4, n } };
        window.updateBreadcrumb = (crumbData, appKey, upCache = true) => { // 挂到window上给platform用
            this.updateBreadcrumb(crumbData, appKey, upCache);
        };
        window.getBreadCrumbInfoByCode = this.getBreadCrumbInfoByCode;
    }
    //更新面包屑
    updateBreadcrumb = (breadcrumbData, appKey, upCache = false) => {
        // let { b1, b2, b3, b4, n } = GetQuery(this.props.location.search);
        // hash值改变之后，location.search并没有变，还是之前的，会导致获取的面包屑数据有问题，原因未知，先取hash解析
        const currentHash = location.hash;
        const pageStr = appKey ? `?page=${appKey}` : currentHash;
        let pageKey = pageStr.match(/(?<=page=)[^&]*/);
        if (pageKey) {
            pageKey = pageKey.pop();
        }
        let { b1, b2, b3, b4, n } = GetQuery(pageStr);
        let breadcrumbInfo = b4 === undefined ? { b1, b2, b3, n } : { b1, b2, b3, b4, n };
        if (typeof breadcrumbData === "function") {
            breadcrumbInfo = breadcrumbData(breadcrumbInfo);
        } else if (isPlainObject(breadcrumbData)) {
            breadcrumbInfo = cloneDeep(breadcrumbData);
        }
        if (upCache) {
            // 更新一下缓存里的
            updateUrlInSesion(pageStr, breadcrumbInfo);
            window.updateMicroOnMain({ type: 'tabTitle', data: breadcrumbInfo.n }, pageKey);
        }
        if (currentHash.includes(pageKey)) {
            this.setState({ breadcrumbInfo });
        }
    }
    handleHomeClick = () => {
        if (isInsideTab()) {
            PubSub.publish('changeInsideTabActived');
        } else {
            openPage("/");
        }
    };
    onItemClick = () => {
        let { onBreadCrumbClick } = this.props;
        let bcInfo = GetQuery(location.hash); // 这里取hash值是因为有的节点是直接带页面参数进入ifr路由打开的，这种情况下this.props.location.search值未更新，会有问题
        if (!bcInfo.b1 && !bcInfo.b2 && !bcInfo.b3) {return;}
        onBreadCrumbClick && onBreadCrumbClick(bcInfo);
    }

    //渲染面包屑
    renderBreadcrumbs = () => {

        let { breadcrumbInfo } = this.state;
        const bcInfo = breadcrumbInfo ? Object.values(breadcrumbInfo) : [];
        const bcLevel = bcInfo.filter(item => item !== undefined).length; //面包屑层级
        const bcList = bcInfo.map(item => {
            const className = bcLevel === 1 ? { className: 'ant-breadcrumb-link not-link' } : {};
            return (
                <Bc.Item onClick={this.onItemClick} {...className}>
                    {item == undefined || item === "undefined" || item === "null" ? null : item}
                </Bc.Item>
            );
        });
        const benchData = [...this.props.benchData];
        const menu = (
            <div className='menu-container'>
                <NCMenu>
                    {
                        benchData.map(item => <Item>
                            <div className={`menu-item ${item.active ? 'active' : ''}`} onClick={() => {
                                if (item.active) {
                                    this.handleHomeClick();
                                    return;
                                }
                                
                                benchData.forEach(bench => {
                                    bench.active = false;
                                });
                                item.active = true;
                                this.props.setWorkbenchData(benchData);
                                this.handleHomeClick();
                                const scrollContainer = document.getElementById('ncWorkbenchHomePage');
                                if (scrollContainer) { // 首页存在
                                    this.props.updateHomePage(() => {
                                        scrollContainer.scrollTop = 0; // 滚动到顶部
                                    });
                                }
                            }}>
                                <img className="menu-item-img" src={item.image || DefaultIcon}></img>
                                <TooltipText text={item.name} className="menu-item-name" />
                                {
                                    item.active && <i className="iconfont icon-xuanzhong icon-active"></i>
                                }
                            </div>
                        </Item>)
                    }
                    {
                        // 留白，出现超出滚动的情况下，为保证显示整数个，遮住超出内容
                        benchData.length > 14 && <React.Fragment>
                            <div className="menu-leave-blank bottom"></div>
                            <div className="menu-leave-blank top"></div>
                        </React.Fragment>
                    }
                </NCMenu>
            </div>
        );
        const homeNode = <span>
            <NCDropdown
                trigger={['hover']}
                overlay={menu}
                animation="slide-up"
                overlayClassName="breadcrumb-bench-dropdown"
            >
                {/* 国际化处理： 首页 */}
                <span className="ant-breadcrumb-link breadcrumb-home" onClick={this.handleHomeClick}>
                    {langCheck("0000PUB-000105")}
                    <div className="breadcrumb-home-icon">
                        {/* <div className="breadcrumb-home-icon-container"></div> */}
                        <i className="iconfont icon-daohangxiala dropdown-icon"></i>
                    </div>
                </span>
            </NCDropdown>
            <span span className="ant-breadcrumb-separator" style={{ cursor: 'auto' }
            }>
                <i className="iconfont icon-mianbaoxie font-size-12"></i>
            </span >
        </span >;
        return [homeNode].concat(bcList);
    }

    //BIP切换语种后已打开的ncc节点面包屑文字不会走新语种，语种不一致时更新一下面包屑
    updateBreadcrumbByLangChange = () => {
        const { search } = this.props.location;
        const { c: appcode, p: pagecode, lang } = GetQuery(search);
        //缓存语种与当前语种不一致更新一下面包屑
        const currentLang = getLangCode();
        if (lang && lang !== currentLang) {
            this.getBreadCrumbInfoByCode(appcode, pagecode).then(bcInfo => {
                this.updateBreadcrumb(bcInfo, null, true);
            })
        }
    }

    getBreadCrumbInfoByCode = (appcode, pagecode) => {
        return new Promise(resolve => {
            ajax({
                url: `/nccloud/platform/appregister/openapp2.do`,
                loading: false,
                data: {
                    appcode,
                    pagecode,
                },
                success: ({ data }) => {
                    const bcInfo = getBreadCrumbInfo(data);
                    resolve(bcInfo);
                },
            });
        })
    }

    componentDidMount() {
        this.updateBreadcrumbByLangChange();
        setTimeout(() => {
            window.addEventListener("hashchange", this.handleHashChange);
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
            const { breadcrumbInfo } = this.state;
            if (breadcrumbInfo.b1 === undefined || isInsideTab()) {
                // 外部网站跳转后更新面包屑（比如 yonbip)
                let { b1, b2, b3, b4, n } = GetQuery(nextProps.location.search);
                this.updateBreadcrumb({ b1, b2, b3, b4, n });
            }
        }
    }

    handleHashChange = () => {
        this.updateBreadcrumbByLangChange();
    }

    componentWillUnmount() {
        window.removeEventListener("hashchange", this.handleHashChange);
    }

    render() {
        return (
            <div className="workbench-breadcrumb">
                {/* <i
                    field="home-icon"
                    className="iconfont icon-zhuye"
                    onClick={this.handleHomeClick}
                /> */}
                <Bc separator={<i className="iconfont icon-mianbaoxie font-size-12" />}>
                    {this.renderBreadcrumbs()}
                </Bc>
            </div>
        );
    }
}
Breadcrumb.propTypes = { onBreadCrumbClick: PropTypes.func };
export default connect(
    state => ({
        benchData: state.appData.workbenchData,
        updateHomePage: state.gridLayoutData.updateHomePage,
    }),
    { setWorkbenchData },
)(withRouter(Breadcrumb));
